import React, { useEffect, useMemo, useState } from "react";
import { Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import toastr from "toastr";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import DatePicker from "app/Components/DateTimeCustom/CustomDateTime";
import MultipleFileUpload from "app/views/custom/components/FileUpload/MultipleFileUpload";
import {
  getCapaById,
  updateCapa,
  updateCapaRevert,
} from "app/_services/ehs/ehsCapaServices";
import { Validation } from "app/_helpers/validation/Validation";
import {
  capaRules,
  capaUpdateRules,
  FORM_LABEL_OFFICER,
} from "app/_pages/_healthSafetyEnvironment/IncidentManagement/CONSTANTS";
import { formatDDMMYYYYbyYYYYMMDD, userDropdownLabel } from "app/_helpers/helper";
import { initialCapa, capaPriorities } from "../IncidentManagement/CONSTANTS";
import BackBtn from "app/Components/CommanComponents/BackBtn";
import { CommmonService } from "app/_services/CommonService/CommonService";
import SimpleSelect from "app/Components/SearchableSelect/SimpleSelect";
import { disableFutureDate } from "app/_helpers/dateHelper";
import IncidentTimeline from "../IncidentManagement/IncidentTimeline";
import VFLTimeline from "../VFL/component/VFLTimeline";
import { getIncidentReportById } from "app/_services/ehs/ehsIncidentServices";
import { getVFLByID } from "app/_services/ehs/VFLService";
import ViewCommentsComponent from "../IncidentManagement/ViewCommentsComponent";
import { VFL_STATUS } from "../VFL/CONSTANTS";
import { getAllAreaOfOperation } from "app/_services/ehs/ehsAreaOfOperationServices";
import YesOrNo from "../YesOrNo.component";
import FormSelect from "app/Components/_form/FormSelect/FormSelect";
import FormInput from "app/Components/_form/FormInput/FormInput";
import CustomDateTime from "app/Components/DateTimeCustom/CustomDateTime";
import { getCapaOwner } from "app/_services/ehs/ehsCapaOwner";
import FormDateTimePicker from "app/Components/_form/FormDatePicker/FormDateTimePicker";

const RevertCapaUpdate = ({
  match: {
    params: { id, siteId },
  },
  history,
}) => {
  const [area, setArea] = useState([]);
  const [capaOwner, setCapaOwner] = useState([]);
  const [showSubAreaText, setShowSubAreaText] = useState(false);

  const [form, setForm] = useState({ ...initialCapa });
  const [oldForm, setOldForm] = useState({ ...initialCapa });
  const [errorForm, setErrorForm] = useState({
    ...initialCapa,
    priority: "",
  });
  const [incidentVflDetails, setIncidentVflDetails] = useState({});
  const [capaComments, setCapaComments] = useState([]);
  const [subArea, setSubArea] = useState([]);
  const [oldSubArea, setOldSubArea] = useState([]);

  const onChange = ({ target: { name, value, type, checked } }) => {
    setForm((prev) => {
      if (name === "areaId") {
        //prev.ownerId = '';
        prev.subAreaId = "";
      }
      return { ...prev, [name]: type === "checkbox" ? checked : value };
    });
  };

  const onChangeDate = ({ name, value }) => {
    setForm((prev) => {
      return { ...prev, [name]: value };
    });
  };

  useEffect(() => {
    const capaOwnerId = capaOwner?.find((d) => form.areaId === d.areaOfOperationId);
    setForm((prev) => ({ ...prev, ownerId: capaOwnerId ? capaOwnerId?.userId : "" }));
  }, [capaOwner, form.areaId]);

  const onSubmit = CommmonService.debounce(async () => {
    let errObj = Validation(
      form,
      capaRules?.map((d) =>
        d?.field_name === "otherSubArea"
          ? form?.subAreaId === 999
            ? { ...d, isRequired: true }
            : { ...d, isRequired: false }
          : d
      )
    );

    setErrorForm(errObj);

    for (const key in errObj) if (errObj[key]) return;

    const response = await updateCapaRevert(id, form);

    if (!response?.status) return toastr.error(response?.message);

    toastr.success("Success");
    history.goBack();
  }, 1500);

  useEffect(() => {
    if (parseInt(form?.subAreaId) === 999) {
      setShowSubAreaText(true);
    } else {
      setShowSubAreaText(false);
    }
  }, [form?.subAreaId]);

  useEffect(() => {
    getAllAreaOfOperation().then((response) => {
      if (!response?.data) return;
      setArea(response.data);
    });

    getCapaOwner().then((response) => {
      if (!response?.data) return;
      setCapaOwner(response.data.capaOwners);
    });
  }, []);

  const areaList = useMemo(
    () =>
      area?.filter(
        (d) =>
          capaOwner
            ?.filter((d) => (siteId ? d.siteId === siteId : true))
            ?.find((data) => d?.id === data?.areaOfOperationId)?.userId
      ),
    [area, capaOwner, siteId]
  );

  useEffect(() => {
    let otherObj = { value: 999, label: "Other", id: 999, name: "Other" };
    const subAreaData = areaList.find((y) => y.id === form?.areaId);
    setSubArea(subAreaData ? [...subAreaData.subAreaOfOperation, otherObj] : []);
  }, [areaList, form?.areaId]);

  useEffect(() => {
    let otherObj = { value: 999, label: "Other", id: 999, name: "Other" };
    const subAreaData = areaList.find((y) => y.id === oldForm?.areaId);
    setOldSubArea(subAreaData ? [...subAreaData.subAreaOfOperation, otherObj] : []);
  }, [areaList, oldForm?.areaId]);

  useEffect(() => {
    getCapaById(id).then((response) => {
      if (!response?.data) return;

      setForm({
        ...response.data,
        closed: response.data.capaStatus === "Closed",
        otherSubArea: response.data.otherSubArea || "",
      });
      setOldForm({ ...response.data, closed: response.data.capaStatus === "Closed" });

      if (response?.data?.source === "Incident Management") {
        getIncidentReportById(response?.data?.incidentDetailsId, "role=reviewer").then(
          (details) => {
            if (!details?.data) return;

            setIncidentVflDetails((prev) => {
              return {
                ...details.data,
                rootCauseAnalysisRequired: details.data.investigationDetails
                  ?.rootCauseAnalysisRequired
                  ? true
                  : false,
              };
            });

            setCapaComments(
              details?.data?.capas?.find((obj) => obj.id === response?.data?.id)
                ?.ehs_capa_reviews
            );
          }
        );
      } else {
        getVFLByID(response?.data?.incidentDetailsData?.vflId).then((details) => {
          if (!details?.data) return;

          setIncidentVflDetails({
            ...details.data,
          });

          setCapaComments(
            details?.data?.vflObservations
              ?.find((o) => o.allCapa?.find((k) => k.id === response?.data?.id))
              ?.allCapa.find((p) => p.id === response?.data?.id)?.ehs_capa_reviews
          );
        });
      }
    });
  }, [id]);

  // useEffect(() => {
  //     getAllAreaOfOperation().then((response) => {
  //         if (!response?.data) return;
  //         const subAreaObj = response.data.find((d) => d.id === form?.workArea?.id);
  //         setSubArea(subAreaObj?.subAreaOfOperation || []);
  //     });
  // }, [form?.workArea?.id]);

  return (
    <div>
      <MainBreadcrumb
        routeSegments={[
          { name: "Health Safety And Environment", path: "#" },
          {
            name: "CAPA Management",
            path: "/health-safety-and-environment/capa-management",
          },
          {
            name: "Manage CAPA",
            path: "/health-safety-and-environment/capa-management/manage-capa",
          },
          {
            name: "Edit",
          },
        ]}
      />
      {/* <Breadcrumb
        routeSegments={[
          { name: "Health Safety And Environment" },
          { name: "Manage CAPA", path: (siteId ? `/sites/${siteId}` : "") + "/health-safety-and-environment/capa-management/manage-capa" },
          { name: "Update CAPA" },
        ]}
      /> */}
      <div className="card p-3 mt-4 overflow-inherit">
        <div className="d-flex justify-content-between simple-card-title">
          <h3 class="text-capitalize mb-0">Edit CAPA</h3>
          {/* {oldForm.capaId && (
                        <div className="mr-3">
                            <label>CAPA ID: {oldForm.capaId}</label>
                        </div>
                    )} */}
        </div>
        <div className="ehsFormWrapper">
          <Row>
            <Col lg={4}>
              <div className="form-group viewbox">
                <h5 className="w-500">Location Name - Location ID</h5>
                <p>
                  {oldForm.site?.name} {oldForm.site?.siteId}
                </p>
              </div>
            </Col>
            <Col lg={4}>
              <div className="form-group viewbox">
                <h5 className="w-500">Source Type</h5>
                <p>
                  {oldForm.source === "ehs_vfl_observations" ? "VFL" : oldForm.source}
                </p>
              </div>
            </Col>
            <Col lg={4}>
              <div className="form-group viewbox">
                <h5 className="w-500">
                  {oldForm?.source === "Incident Management" ? "Incident" : "VFL"} ID
                </h5>
                {oldForm?.source === "Incident Management" ? (
                  <Link
                    to={
                      "/health-safety-and-environment/incident-management/review/view/" +
                      incidentVflDetails.id
                    }
                    target="_blank"
                    className=""
                  >
                    <p>{incidentVflDetails?.incidentId}</p>
                  </Link>
                ) : (
                  <Link
                    to={
                      incidentVflDetails.vflStatus === VFL_STATUS.completed
                        ? "/health-safety-and-environment/vfl/completion/view/" +
                          incidentVflDetails.id
                        : "/health-safety-and-environment/vfl/view/" +
                          incidentVflDetails.id
                    }
                    target="_blank"
                    className=""
                  >
                    <p>{incidentVflDetails?.vflId}</p>
                  </Link>
                )}
              </div>
            </Col>
            <Col lg={4}>
              <div className="form-group viewbox">
                <h5 className="w-500">CAPA ID</h5>
                <p>{oldForm.capaId}</p>
              </div>
            </Col>
            <Col lg={4}>
              <div className="form-group viewbox">
                <h5 className="w-500">Source Area</h5>
                <p>{oldForm.workArea?.name}</p>
              </div>
            </Col>
            <Col lg={4}>
              <div className="form-group viewbox">
                <h5 className="w-500">Sub Area</h5>
                <p>{oldSubArea.find((d) => d.id === oldForm?.subAreaId)?.name}</p>
              </div>
            </Col>
            {oldForm?.subAreaId === 999 && (
              <Col lg={4}>
                <div className="form-group viewbox">
                  <h5 className="w-500">Other Sub Area</h5>
                  <p>{oldForm?.otherSubArea}</p>
                </div>
              </Col>
            )}
            <Col lg={4}>
              <div className="form-group viewbox">
                <h5 className="w-500">CAPA Owner</h5>
                <p>{userDropdownLabel(oldForm.owner)}</p>
              </div>
            </Col>
            <Col lg={4}>
              <div className="form-group viewbox">
                <h5 className="w-500">Priority</h5>
                <p>{capaPriorities[oldForm.priority]}</p>
              </div>
            </Col>
            <Col lg={4}>
              <div className="form-group viewbox">
                <h5 className="w-500">Due Date</h5>
                <p>{formatDDMMYYYYbyYYYYMMDD(oldForm.dueDate)}</p>
              </div>
            </Col>
            <Col lg={4}>
              <div className="form-group viewbox">
                <h5 className="w-500 mb-1">Created Date</h5>
                <p>{formatDDMMYYYYbyYYYYMMDD(oldForm.createdAt)}</p>
              </div>
            </Col>
            <Col lg={8}>
              <div className="form-group viewbox">
                <h5 className="w-500 mb-1">CAPA Description</h5>
                <p>{oldForm.solution}</p>
              </div>
            </Col>
            <Col lg={12}>
              <div className="form-group viewbox">
                <h5 className="w-500 mb-1">Return Message</h5>
                <p>{oldForm?.revertMessage}</p>
              </div>
            </Col>
          </Row>
          <Row>
            <Col lg={4}>
              <div className="form-group viewbox">
                <h5 className="w-500 mb-1">CAPA Type</h5>
                <SimpleSelect
                  className="form-control"
                  name="capaType"
                  value={form?.capaType}
                  onChange={onChange}
                  id="id"
                  label="name"
                  options={["Corrective", "Preventive"]}
                  error={errorForm?.capaType}
                  init="none"
                  array="single"
                ></SimpleSelect>
                <span className="small text-danger">{errorForm?.capaType}</span>
              </div>
            </Col>
            <Col lg={4}>
              <div className="form-group viewbox">
                <h5 className="w-500 mb-1">CAPA Description</h5>
                <input
                  value={form.solution}
                  name="solution"
                  onChange={onChange}
                  className="form-control"
                />
                <span className="small text-danger">{errorForm?.solution}</span>
              </div>
            </Col>
            <Col lg={4}>
              <div className="form-group viewbox">
                <h5 className="w-500 mb-1">Area</h5>
                <SimpleSelect
                  className="form-control"
                  name="areaId"
                  value={form.areaId}
                  onChange={onChange}
                  id="id"
                  label="name"
                  options={areaList}
                  error={errorForm?.areaId}
                  init="Select"
                  // disabled
                ></SimpleSelect>
                <span className="small text-danger">{errorForm.areaId}</span>
              </div>
            </Col>
            <Col lg={4}>
              <div className="form-group viewbox">
                <h5 className="w-500 mb-1">Sub Area</h5>
                <SimpleSelect
                  className="form-control"
                  name="subAreaId"
                  value={+form.subAreaId}
                  onChange={onChange}
                  id="id"
                  label="name"
                  options={subArea}
                  error={errorForm?.subAreaId}
                  init="Select"
                  // disabled
                ></SimpleSelect>
                <span className="small text-danger">{errorForm.subAreaId}</span>
              </div>
            </Col>
            {showSubAreaText && (
              <>
                <Col lg={4}>
                  <div className="form-group viewbox">
                    <h5 className="w-500 mb-1">Other Sub Area</h5>
                    <FormInput
                      className="form-control"
                      name="otherSubArea"
                      value={form?.otherSubArea}
                      onChange={onChange}
                      id="id"
                      //   label="Other Sub Area"
                      error={errorForm?.otherSubArea}
                      //   disabled
                    ></FormInput>
                  </div>
                </Col>
                {/* <span className="small text-danger">{errorForm.otherSubArea}</span> */}
              </>
            )}

            <Col lg={4}>
              <div className="form-group viewbox">
                <h5 className="w-500 mb-1">CAPA Owner</h5>
                <select
                  value={form.ownerId}
                  name="ownerId"
                  onChange={onChange}
                  capasErrors={errorForm?.ownerId}
                  className="form-control"
                  disabled
                >
                  {/* <option value="">Select</option> */}

                  {capaOwner.map((data, idx) => {
                    if (form.areaId === data.areaOfOperationId) {
                      return (
                        <option key={idx} value={data.userId}>
                          {data.user.firstName} {data.user.lastName}
                        </option>
                      );
                    }
                    return null;
                  })}
                </select>
                <span className="small text-danger">{errorForm.ownerId}</span>
              </div>
            </Col>
            <Col lg={4}>
              <div className="form-group viewbox">
                <h5 className="w-500 mb-1">CAPA Priority</h5>
                <SimpleSelect
                  value={form.priority}
                  name="priority"
                  onChange={onChange}
                  className="form-control"
                  options={Object.keys(capaPriorities)}
                  object={capaPriorities}
                  error={errorForm?.priority}
                ></SimpleSelect>
                <span className="small text-danger">{errorForm.priority}</span>
              </div>
            </Col>
            <Col lg={4}>
              <div className="form-group viewbox">
                <h5 className="w-500 mb-1">Due Date</h5>
                <CustomDateTime
                  name="dueDate"
                  value={form.dueDate}
                  closeOnSelect
                  readOnly
                  error={errorForm?.dueDate}
                  onChange={(moment, name) => {
                    onChangeDate({
                      name,
                      value: moment.format("YYYY-MM-DD"),
                    });
                  }}
                  //{...(isValidDate ? { isValidDate } : {})}
                />
              </div>
            </Col>
          </Row>
          <div className="mb-2 text-center">
            <Button
              onClick={onSubmit}
              type="submit"
              variant="primary"
              className="m-1 text-capitalize"
            >
              Update CAPA
            </Button>
          </div>
        </div>
      </div>
      <div className="mt-4 text-center">
        <span className="btn btn-secondary mx-2" onClick={() => history.goBack()}>
          Go Back
        </span>
      </div>
    </div>
  );
};

export default RevertCapaUpdate;
